/*
 * This file is auto-generated. Do not modify it manually!
 * Run 'yarn workspace @proton/icons build' to update the icons react components.
 */
import React from 'react';

import type { IconSize } from '../types';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    /** If specified, renders an sr-only element for screenreaders */
    alt?: string;
    /** If specified, renders an inline title element */
    title?: string;
    /**
     * The size of the icon
     * Refer to the sizing taxonomy: https://design-system.protontech.ch/?path=/docs/components-icon--basic#sizing
     */
    size?: IconSize;
}

export const IcBrandTor = ({ alt, title, size = 4, className = '', viewBox = '0 0 16 16', ...rest }: IconProps) => {
    return (
        <>
            <svg
                viewBox={viewBox}
                className={`icon-size-${size} ${className}`}
                role="img"
                focusable="false"
                aria-hidden="true"
                {...rest}
            >
                {title ? <title>{title}</title> : null}

                <path
                    fillRule="evenodd"
                    d="M8 1a.5.5 0 0 1 .464.314c.45 1.123 1.259 1.877 2.118 2.517.215.16.43.312.643.46l.07.049c.188.131.376.263.554.393.393.288.776.6 1.051.967.69.919 1.1 2.062 1.1 3.3 0 1.542-.76 3.038-1.86 4.14C11.037 14.24 9.541 15 8 15c-1.542 0-3.038-.76-4.14-1.86C2.76 12.037 2 10.541 2 9c0-1.238.41-2.381 1.1-3.3.275-.366.658-.679 1.051-.967.178-.13.366-.262.555-.393l.069-.048c.213-.15.428-.3.643-.46.86-.641 1.669-1.395 2.118-2.518A.5.5 0 0 1 8 1ZM4.743 5.54c-.38.278-.662.519-.844.76A4.478 4.478 0 0 0 3 9c0 1.219.61 2.473 1.568 3.432.427.426.912.784 1.426 1.05a4.702 4.702 0 0 1-.482-.642C4.894 11.86 4.5 10.515 4.5 9c0-1.163.45-2.045.887-2.896l.166-.328c.278-.556.523-.948.745-1.301l.072-.115c-.119.095-.237.186-.354.273-.229.17-.455.33-.669.479l-.069.048c-.19.132-.368.257-.535.38ZM7.5 4.422c-.133.237-.269.456-.408.678-.21.339-.427.686-.645 1.123l-.169.335C5.837 7.428 5.5 8.09 5.5 9c0 1.349.353 2.504.858 3.307.356.565.759.918 1.142 1.083V4.423Zm1 9.544c1.056-.14 2.104-.707 2.932-1.535C12.391 11.473 13 10.219 13 9a4.478 4.478 0 0 0-.9-2.7c-.18-.241-.463-.482-.843-.76-.167-.123-.345-.248-.535-.38a26.15 26.15 0 0 1-.737-.527c-.502-.374-1.024-.81-1.485-1.355v10.689Z"
                ></path>
            </svg>
            {alt ? <span className="sr-only">{alt}</span> : null}
        </>
    );
};
